<template lang="html">
<div class="payment-channel">
  <row>
    <div class="sl-col-4 flex">
      <div class="sl-box" v-for="item,index in open" v-loading="item.loading">
        <div class="sl-top">
        </div>
        <div class="sl-img">
          <img :src="`/static/imgs/${item.channelId}.png`" alt="">
        </div>
        <div class="sl-channel">
          <p class="sl-name">{{item.channelName}}</p>
          <p>
            <span>{{$t('Views.ServiceFee.t')}}</span>
            <span><strong>{{item.rate}}%</strong></span>
          </p>
        </div>
        <div class="sl-charge">
          <span>{{$t('Views.ServiceFee.st')}}</span>
          <el-switch v-model="item.chargeFee" on-text="" off-text="" @change="OnChargeFee(index)" :width="40"></el-switch>
        </div>
        <div class="sl-line"></div>
        <div class="sl-rate" :class="{'sl-error':item.error}" v-show="item.chargeFee">
          <span class="sl-del">{{$t('Views.ServiceFee.r')}}</span>
          <input type="number" v-model="item.cRate" class="sl-input" @input="onInput(index)" @change="onChange(index)" @focus="onFocus(index)" step="0.1">
          <span>%</span>
        </div>
        <div class="sl-rate-dis" v-show="!item.chargeFee">
          {{$t('Views.ServiceFee.mf')}}
        </div>
        <div class="sl-error-msg" v-show="item.error">
          <span>* {{$t('Views.ServiceFee.sf')}}</span>
          <span>than {{item.maxRate}} %</span>

        </div>

        <div v-show="item.save" class="sl-btn">
          <button type="button" name="button" @click="cancel(index)">{{$t('Functional.cancel')}}</button>
          <button type="button" name="button" @click="confirm(index)">{{$t('Functional.save')}}</button>
        </div>
      </div>

    </div>
  </row>
  <row>
    <div class="sl-col-4" style="text-align: center;">
      <button class="sl-go-dashboard" :class="{'sl-btn-disable':nextBtn}" @click="gotoDashboard" :disabled="nextBtn">{{$t('Functional.next')}}</button>
    </div>
  </row>

</div>
</template>

<script>
import * as types from '../../store/types'
import api from '../../api'
import compute from '../../util/compute'
export default {
  name: 'Service-fee-setting',
  data() {
    return {
      open: [],
      available: [],
      newUser: true,
      btnDisable: true
    }
  },
  computed: {
    nextBtn() {
      let flag = false
      for (let i = 0; i < this.open.length; i++) {
        if (this.open[i].save) {
          flag = true
        }
      }
      return flag
    }
  },
  created() {
    initPage(this)
  },
  methods: {
    gotoDashboard() {
      this.$ga.event('Link', 'Go to Dashboard', 'Service Fee')
      const vm = this
      api.FinishOnboarding().then(res => {
        if (res.data.code === 200) {
          vm.$store.commit(types.SETFEE)
          vm.$router.push({
            name: 'Dashboard',
            query: {
              new: '1'
            }
          })
        }
      })
    },
    goto() {
      this.newUser = false
    },
    onFocus(i) {
      let item = this.open.splice(i, 1)[0]
      item.save = true
      this.open.splice(i, 0, item)
    },
    OnChargeFee(i) {
      let item = this.open.splice(i, 1)[0]
      this.open.splice(i, 0, item)
      if (item.chargeFee === false) {
        // item.cRate = 0
        item.rateStatus = 1
        this.confirm(i)
      } else {
        item.rateStatus = 2
        this.confirm(i)
      }
    },
    OnActive(i) {
      let item = this.available.splice(i, 1)[0]
      this.available.splice(i, 0, item)
      this.active(i)
    },
    validateCRate(val) {
      if (val < 0) {
        this.$message.error(this.$t('Views.PaymentChannel.msg2'))
        return false
      }
      return true
    },
    onInput(i) {
      const self = this.open[i]
      if (self.cRate.toString().length > 4) {
        self.cRate = self.cRate.toString().slice(0, 4)
      }
    },
    onChange(i) {
      const self = this.open[i]
      // this.validateCRate(self.cRate)
      if (self.cRate > self.maxRate) {
        this.open.splice(i, 1, Object.assign(self, {
          error: true
        }))
      } else {
        this.open.splice(i, 1, Object.assign(self, {
          error: false
        }))
      }
    },
    errorMsg(res) {
      this.$notify.error({
        title: 'failed',
        message: res.data.msg
      })
    },
    successMsg(res) {
      this.$notify.success({
        title: 'success',
        message: res.data.msg
      })
    },
    cancel(i) {
      this.$ga.event('Button', 'Cancel', 'Service Fee')
      let item = this.open.splice(i, 1)[0]
      item.save = false
      item.error = false
      item.cRate = item.defaultRate
      this.open.splice(i, 0, item)
    },
    confirm(i) {
      this.$ga.event('Button', 'Confirm', 'Service Fee')
      let item = this.open[i]
      const vm = this
      if (!this.validateCRate(item.cRate)) {
        return false
      }
      if (item.cRate > item.maxRate) {
        this.$notify.error({
          title: 'error',
          message: `Service fee cannot be set higher than ${item.maxRate}%`
        })
        return false
      }
      if (item.chargeFee === false) {
        item.cRate = item.defaultRate
      }
      item.loading = true
      api.UpdateChannel(item.channelId, {
        cRate: compute.div(item.cRate, 100),
        rateStatus: item.rateStatus
      }).then(res => {
        if (res.data.code === 200) {
          vm.btnDisable = false
          vm.successMsg(res)
          vm.open.splice(i, 1, vm.initActive(res.data.data))
        } else {
          vm.errorMsg(res)
        }
        item.loading = false
      })
    },
    disable(i) {
      let item = this.open[i]
      const vm = this
      item.loading = true
      api.DeleteChannel(item.channelId).then(res => {
        if (res.data.code === 200) {
          vm.successMsg(res)
          initPage(vm)
        } else {
          vm.errorMsg(res)
        }
        item.loading = false
      })
    },
    active(i) {
      let item = this.available[i]
      const vm = this
      item.loading = true
      api.ActiveChannel(item.channelId).then(res => {
        if (res.data.code === 200) {
          vm.successMsg(res)
          initPage(vm)
        } else {
          vm.errorMsg(res)
        }
        item.loading = false
      })
    },
    initActive(item) {
      return Object.assign(item, {
        save: false,
        error: false,
        loading: false,
        chargeFee: item.rateStatus === '2' ? true : !true,
        // defaultRate: compute.mul(item.cRate, 100),
        // cRate: compute.mul(item.cRate, 100),
        defaultRate: Number((item.cRate * 100).toFixed(2)),
        cRate: Number((item.cRate * 100).toFixed(2)),
        rate: compute.mul(item.rate, 100),
        maxRate: compute.mul(item.maxRate, 100),
        active: true
      })
    }
  }
}

function initPage(vm) {
  api.FetchChannel().then(res => {
    vm.open = res.data.data.open
    vm.available = res.data.data.available
    vm.open.map(item => {
      item.save = item.error = item.loading = false
      item.chargeFee = item.rateStatus === '2' ? true : !true
      // item.defaultRate = item.cRate = compute.mul(item.cRate, 100)
      item.defaultRate = item.cRate = Number((item.cRate * 100).toFixed(2))
      item.rate = compute.mul(item.rate, 100)
      item.maxRate = compute.mul(item.maxRate, 100)
    })
    vm.available.map(item => {
      item.rate = compute.mul(item.rate, 100)
      item.loading = false
    })
  })
}
</script>

<style scoped>
.sl-box {
  height: 340px;
  width: 220px;
  min-width: 220px;
  background: #FFFFFF;
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.10);
  border-radius: 2px;
  margin: 20px 10px;
  position: relative;
}

.flex {
  display: flex;
}

.sl-top {
  height: 16px;
  padding: 20px;
  position: relative;
}

.sl-top i {
  display: inline-block;
  height: 16px;
  width: 16px;
  background: #72B524;
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.10);
  border-radius: 50%;
}

.sl-top span {
  font-family: Avenir-Book;
  font-size: 10px;
  color: #9B9B9B;
  letter-spacing: 0;
  padding-left: 10px;
  line-height: 16px;
  height: 16px;
  position: absolute;
  bottom: 3px;
}

.sl-img {
  width: auto;
  height: 60px;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;
}

.sl-img img {
  width: 48px;
  height: 48px;
}

.sl-btm {
  text-align: center;
  position: relative;
  top: 20px;
}

.sl-btm button {
  width: 75px;
  height: 30px;
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  border-radius: 2px;
  font-family: Avenir-Book;
  font-size: 13px;
  color: #4A4A4A;
  letter-spacing: 0;
  line-height: 13px;
}

.sl-input.sl-input-active {
  border: 1px solid #062241 !important;
}

.sl-btm button:nth-child(1) {
  margin-right: 10px;
}

.sl-btm button.sl-cancel {
  border: 0;
}

.sl-btm button.sl-edit:hover {
  background: #062241;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.10);
  border-radius: 2px;
}

.sl-btm button.sl-active:hover {
  background: #64BF2B;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.10);
  border-radius: 2px;
}

.sl-btm button.sl-disable:hover {
  background: #64BF2B;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.10);
  border-radius: 2px;
}

.sl-rate {
  position: relative;
}

.sl-rate .sl-input {
  background: #F7F7F7;
  border: 1px solid #E0E0E0;
  border-radius: 2px;
  width: 55px;
  height: 30px;
  position: relative;
  right: -130px;
  font-family: Avenir-Book;
  font-size: 18px;
  color: #4A4A4A;
  letter-spacing: 0;
}

.sl-rate span {
  position: absolute;
  font-family: Avenir-Book;
  font-size: 14px;
  letter-spacing: 0;
  top: 6px;
  right: 20px;
}

.sl-rate span.sl-del {
  font-family: Avenir-Book;
  font-size: 12px;
  color: #4A4A4A;
  letter-spacing: 0;
  line-height: 10px;
  position: absolute;
  top: 10px;
  right: 115px;
}

.sl-error-msg {
  position: relative;
  margin: 0 15px;
}

.sl-error-msg span {
  font-family: Avenir-Book;
  font-size: 12px;
  color: #D61010;
  letter-spacing: 0;
}

.sl-error input.sl-input {
  background: #FFF0F0;
  border: 1px solid #D61010 !important;
  border-radius: 2px;
  font-family: Avenir-Book;
  font-size: 18px;
  color: #D61010;
  letter-spacing: 0;
}

.sl-name {
  font-family: Avenir-Medium;
  font-size: 14px;
  color: #4A4A4A;
  letter-spacing: 0;
  line-height: 14px;
}

.sl-channel {
  text-align: center;
}

.sl-charge {
  padding: 10px 0 5px;
  border-top: 1px solid #F3F3F3;
  margin: 0 auto;
  text-align: center;
}

.sl-charge span {
  font-family: Avenir-Book;
  font-size: 12px;
  color: #4A4A4A;
  letter-spacing: 0;
  padding-right: 10px;
  display: inline-block;
  max-width: 150px;
  text-align: left;
}

.sl-available .sl-img {
  margin: 78px auto 0;
}

.sl-available .sl-channel p {
  font-family: Avenir-Medium;
  font-size: 14px;
  color: #9B9B9B;
  letter-spacing: 0;
  line-height: 14px;
}

.sl-rate-dis {
  font-family: Avenir-Book;
  font-size: 12px;
  color: #4A4A4A;
  letter-spacing: 0;
  line-height: 12px;
  text-align: center;
  margin-top: 30px;
}

.sl-btn {
  position: absolute;
  text-align: center;
  bottom: 16px;
  width: 220px;
}

.sl-btn button {
  background: #fff;
  border: none;
  font-family: Avenir-Book;
  font-size: 16px;
  color: #9B9B9B;
  letter-spacing: 0;
  line-height: 16px;
}

.sl-btn button:nth-child(2) {
  color: #2B90E9;
}

.sl-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.70);
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.10);
  border-radius: 2px;
  overflow-y: hidden;
}

.sl-block-welcome {
  width: 460px;
  height: 300px;
  background: #FFFFFF;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.10);
  border-radius: 2px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -230px;
  margin-top: -150px;
  text-align: center;
}

.sl-title {
  font-family: Avenir-Medium;
  font-size: 24px;
  color: #4A4A4A;
  line-height: 16px;
  padding-top: 48px;
  text-align: center;
}

.sl-cnt {
  max-width: 350px;
  margin: 0 auto;
  text-align: center;
  padding-top: 50px;
}

.sl-mask .sl-btn {
  font-family: Avenir-Medium;
  font-size: 14px;
  color: #FFFFFF;
  background: #2B90E9;
  border-radius: 2px;
  height: 36px;
  line-height: 36px;
  width: 160px;
  text-align: center;
  margin: 40px auto 0;
  cursor: pointer;
  position: relative;
}

.sl-line {
  width: 180px;
  height: 4px;
  margin: 0 auto 5px;
  background-image: url(../../assets/imgs/line.png);
  background-repeat: no-repeat;
  background-size: cover;
}

.sl-go-dashboard {
  background: #2B90E9;
  border-radius: 2px;
  font-family: Avenir-Book;
  font-size: 14px;
  color: #fff;
  letter-spacing: 0;
  border: none;
  padding: 10px;
}

.sl-go-dashboard.sl-btn-disable {
  background-color: #d7d7d7;
}

@media only screen and (max-width: 500px) {
  .flex {
    flex-direction: column;
  }
  .sl-box {
    margin: 10px auto;
  }
}
</style>


<style>
div.payment-channel .el-switch--wide .el-switch__label span {
  top: 8px;
  left: 65px;
  width: 150px;
  display: inline-block;
  font-family: Avenir-Book;
  font-size: 10px;
  color: #2B90E9;
  letter-spacing: 0;
  line-height: 8px;
}

div.payment-channel .el-switch--wide .el-switch__label.el-switch__label--right span {
  font-family: Avenir-Book;
  font-size: 8px;
  color: #9B9B9B;
  letter-spacing: 0;
  line-height: 8px;
}
</style>



// WEBPACK FOOTER //
// service-fee.vue?3b440ae0